export const priorityNames = ['Hot', 'Warm', 'Cold', 'Follow-up', 'Archived']
